var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quote-board-page"},[_c('iframe',{ref:"boardFrame",staticClass:"board-iframe",attrs:{"src":_vm.boardSrc,"frameborder":"0","allowfullscreen":""},on:{"load":_vm.onFrameLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }